export default __webpack_public_path__ + "static/media/Chefbro.d66d2210.png";